import { render, staticRenderFns } from "./ShiftCreateDialog.vue?vue&type=template&id=180cf9ac&"
import script from "./ShiftCreateDialog.vue?vue&type=script&lang=js&"
export * from "./ShiftCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports